import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-slate-950 pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white mb-8">
          Política de Privacidade
        </h1>
        
        <div className="bg-slate-900 border border-blue-900/30 rounded-2xl p-8 space-y-6 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              1. Coleta de Dados
            </h2>
            <p className="leading-relaxed">
              A Gotelip Assistência Técnica coleta as seguintes informações quando você 
              preenche nosso formulário de contato: nome completo, endereço de email, 
              número de telefone/WhatsApp, tipo de dispositivo e descrição do problema técnico.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              2. Finalidade do Uso dos Dados
            </h2>
            <p className="leading-relaxed mb-2">
              Seus dados pessoais são utilizados exclusivamente para as seguintes finalidades:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Entrar em contato para esclarecer e avaliar sua solicitação de serviço</li>
              <li>Prestar o serviço de assistência técnica solicitado</li>
              <li>Enviar atualizações sobre o status do seu reparo</li>
              <li>Manter histórico de atendimentos para melhor qualidade do serviço</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              3. Compartilhamento de Dados
            </h2>
            <p className="leading-relaxed">
              A Gotelip <strong>NÃO</strong> compartilha, vende, aluga ou divulga suas 
              informações pessoais para terceiros. Seus dados são mantidos em total 
              confidencialidade e são acessados apenas pela nossa equipe técnica.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              4. Armazenamento e Segurança
            </h2>
            <p className="leading-relaxed">
              Seus dados são armazenados em servidores seguros com:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Criptografia de dados em trânsito (HTTPS/SSL)</li>
              <li>Senhas com hash criptográfico (bcrypt)</li>
              <li>Proteção contra acessos não autorizados</li>
              <li>Backup regular dos dados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              5. Seus Direitos (LGPD - Lei Geral de Proteção de Dados)
            </h2>
            <p className="leading-relaxed mb-2">
              De acordo com a LGPD (Lei nº 13.709/2018), você tem os seguintes direitos:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li><strong>Acesso:</strong> Solicitar acesso aos seus dados pessoais</li>
              <li><strong>Correção:</strong> Corrigir dados incompletos, inexatos ou desatualizados</li>
              <li><strong>Exclusão:</strong> Solicitar a exclusão dos seus dados</li>
              <li><strong>Portabilidade:</strong> Receber seus dados em formato estruturado</li>
              <li><strong>Revogação:</strong> Revogar o consentimento a qualquer momento</li>
              <li><strong>Oposição:</strong> Opor-se ao tratamento dos seus dados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              6. Retenção de Dados
            </h2>
            <p className="leading-relaxed">
              Mantemos seus dados pelo período necessário para prestação do serviço e 
              cumprimento de obrigações legais. Após esse período, os dados são excluídos 
              de forma segura.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              7. Cookies e Tecnologias Similares
            </h2>
            <p className="leading-relaxed">
              Nosso site utiliza apenas cookies essenciais para funcionamento básico 
              (autenticação de administradores). Não utilizamos cookies de rastreamento 
              ou publicidade.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              8. Alterações nesta Política
            </h2>
            <p className="leading-relaxed">
              Esta Política de Privacidade pode ser atualizada periodicamente. 
              Recomendamos que você revise esta página regularmente para se manter 
              informado sobre como protegemos suas informações.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">
              9. Contato e Dúvidas
            </h2>
            <p className="leading-relaxed mb-3">
              Para exercer seus direitos, tirar dúvidas ou fazer solicitações relacionadas 
              à privacidade, entre em contato:
            </p>
            <div className="bg-slate-800 rounded-lg p-4 space-y-2">
              <p>
                <strong className="text-white">WhatsApp:</strong>{' '}
                <a 
                  href="https://wa.me/5567981556252?text=Olá, tenho uma dúvida sobre privacidade de dados" 
                  className="text-blue-400 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  67 98155-6252
                </a>
              </p>
              <p>
                <strong className="text-white">Instagram:</strong>{' '}
                <a 
                  href="https://instagram.com/gotelip.assistencia" 
                  className="text-blue-400 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @gotelip.assistencia
                </a>
              </p>
              <p>
                <strong className="text-white">Localização:</strong> Campo Grande - MS
              </p>
            </div>
          </section>

          <div className="text-sm text-gray-500 mt-8 pt-6 border-t border-blue-900/30 flex justify-between items-center">
            <span>Última atualização: {new Date().toLocaleDateString('pt-BR')}</span>
            <Link to="/" className="text-blue-400 hover:underline">
              Voltar para Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
